import styled from 'styled-components';

/**
 * Shared wrapper for filter options that dims and disables pointer events
 * when the option would return zero results. Used by all FilterOptions
 * variants except DefaultCheckbox (which bakes disabled styles into its
 * own OptionItem).
 */
const DisabledOptionWrapper = styled.li<{ $disabled?: boolean }>`
  opacity: ${({ $disabled }) => ($disabled ? '0.35' : '1')};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  transition: opacity 0.2s ease;
`;

export default DisabledOptionWrapper;
